exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.title-text-modal {\r\n    /* font-size: 20px; */\r\n    font-family: worksans;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    line-height: 24px;\r\n    letter-spacing: -0.02em;\r\n    text-align: left;\r\n    color: #384149;\r\n    margin: 0 !important;\r\n\r\n}\r\n.subtitle-text-modal {\r\n    /* font-size: 17px; */\r\n    font-size: 25px;\r\n    font-weight: 450;\r\n    line-height: 2;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/title-modal/title-modal.component.css
// module id = ../../../../../src/app/components/title-modal/title-modal.component.css
// module chunks = main